<div class="bmc-ai-jobs-description">
  <div class="bmc-ai-jobs-description__header">
    <h4 class="bmc-ai-jobs-description__title bz-font-weight--semibold">{{'AIJOBS.DESCRIPTION_TITLE' | translate}}</h4>
  </div>
  <div *ngIf="!job" class="bmc-ai-jobs-description__no-selection">
    <h3>{{'AIJOBS.NO_AIJOB_SELECTED' | translate}}</h3>
  </div>
  <div class="bmc-ai-jobs-description__tabs" *ngIf="job">
    <bzg-tab-set (onSelectTab)="selectedTab = $event.index">
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'AIJOBS.SETTINGS' | translate | uppercase}}">
        <job-settings class="bmc-ai-jobs-description__tabs__component-container" [jobType]="jobType" [currentJob]="job"
                      (saveJob)="saveUserJob($event)" (cancel)="validatePendingChanges()" (reset)="reset()"></job-settings>
      </bzg-tab-item>
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'AIJOBS.AIJOB_EXECUTION' | translate | uppercase}}">
        <job-execution class="bmc-ai-jobs-description__tabs__component-container" [jobType]="jobType" [userJobGuid]="job.guid"></job-execution>
      </bzg-tab-item>
    </bzg-tab-set>
  </div>
</div>
